import React from 'react';
import { UserInfo } from 'firebase';

export interface UserData extends UserInfo {
  name: string,
  groupIds: string
}

const AuthUserContext = React.createContext<UserData | null>(null);
export default AuthUserContext;
